import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import axios from "axios";
import { BASE_URL } from "../../../constant";
import { toast } from "react-toastify";
import { formatDate } from "@telerik/kendo-intl";
import AppContext from "../../../AppContext";
import KendoLoadingPanel from "../../KendoLoadingPanel";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";

const FuelList = () => {
  const navigate = useNavigate();
  const { authCtx, darkMode } = useContext(AppContext);
  const { t } = useTranslation();

  const onEditClick = (e) => {
    navigate(`/fuelform/${e.dataItem.id}`);
  };

  const ActionCell = (e) => {
    return (
      <td className="">
        <button
          className="flex flex-col justify-center items-center gap-1"
          onClick={() => onEditClick(e)}
        >
          <ReactSVG
            src="EditIcon.svg"
            className="w-5 h-5 flex items-center justify-center "
            beforeInjection={(svg) => {
              svg.setAttribute(
                "style",
                `stroke: ${darkMode ? "white" : "black"}`
              );
            }}
          ></ReactSVG>
        </button>
      </td>
    );
  };

  const DateCell = (props) => {
    return (
      <td>
        {formatDate(new Date(props.dataItem[props.field]), "dd-MMM-yyyy")}
      </td>
    );
  };

  const columns = [
    {
      field: "fuelType",
      title: t("masters.fields.fuelType"),
      show: true,
      width: 160,
      filterable: true,
    },
    {
      field: "date",
      title: t("masters.fields.date"),
      show: true,
      width: 160,
      filterable: true,
      cell: DateCell,
    },
    {
      field: "value",
      title: t("masters.fields.value"),
      show: true,
      width: 500,
      filterable: true,
    },
    {
      field: "currency",
      title: t("masters.fields.currency"),
      show: true,
      width: 100,
      filterable: true,
    },
    {
      field: "",
      title: t("masters.fields.action"),
      show: true,
      width: 150,
      filterable: true,
      cell: ActionCell,
    },
  ];
  const [stateColumns, setStateColumns] = React.useState(columns);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    try {
      setLoading(true);
      const companyId = authCtx.profile?.companyId || "";
      const res = await axios.get(
        `${BASE_URL}/api/Fuel?companyId=${companyId}&userRole=${authCtx.profile.role}`
      );
      setData(res.data);
      setFilteredData(res.data);
      setLoading(false);
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
      // else toast.error("An error occured");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="flex flex-col text-white px-14 py-7 dark:bg-neutral-900 bg-white h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          <div className="flex text-base font-medium gap-3 items-center dark:text-white text-black">
            <button onClick={() => navigate("/settings")}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                />
              </svg>
            </button>
            <label className="dark:text-white text-black">
              {t("masters.headerTexts.fuelMaster")}
            </label>
          </div>
          <hr className="rotate-90 w-10 h-1 border-zinc-800"></hr>
          {/* <label className="text-zinc-600 text-sm font-medium">
            {t("masters.headerTexts.fuelMaster")}
          </label> */}
          <div>
            <form>
              <div className="relative dark:bg-gray-900 bg-zinc-400 to-zinc-600 w-80 h-9 rounded-lg border-zinc-800">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 text-neutral-700"
                    fill="none"
                    stroke={darkMode ? "white" : "black"}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    ></path>
                  </svg>
                </div>
                <input
                  type="search"
                  id="default-search"
                  className="block h-full pl-10 w-full text-sm font-normal bg-inherit dark:text-white text-black dark:placeholder:text-white placeholder:text-black rounded-lg"
                  placeholder={t("masters.placeholders.fuelSearch")}
                  required
                />
              </div>
            </form>{" "}
          </div>
        </div>
        <div className="flex dark:text-white text-black">
          <button
            type="button"
            onClick={() => navigate("/fuelform/new")}
            className="flex text-sm font-medium h-9 w-48 dark:bg-indigo-700 bg-[#00C6C2] rounded-4xl justify-center items-center gap-2 leading-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {t("button.addFuel")}
          </button>
        </div>
      </div>
      <div
        className={`h-5/6 mt-4 w-full mb-16 ${
          darkMode ? "darkGrid" : "lightGrid"
        }`}
      >
        {loading && <KendoLoadingPanel />}
        <Grid
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "#181921",
            borderRadius: "15px",
            textAlign: "justify",
            overflowY: "auto",
            scrollbarGutter: "auto",
            scrollBehavior: "smooth",
            scrollbarWidth: "auto",
          }}
          data={filteredData}
        >
          {stateColumns.map(
            (column, idx) =>
              column.show && (
                <GridColumn
                  key={idx}
                  field={column.field}
                  title={column.title}
                  filterable={column.filterable}
                  cell={column.cell}
                  width={"auto"}
                  className="product-name"
                />
              )
          )}
        </Grid>
        <br />
      </div>
    </div>
  );
};

export default FuelList;
